import { CollectionButton } from 'components/CollectionButton/CollectionButton'
import { collections } from 'data/collections'
import { useMemo } from 'react'

import styled from 'styled-components'
import { useWindowSize } from 'usehooks-ts'

export const CollectionButtons = ({
  handleAnswer,
  item,
}: {
  handleAnswer: (collectionid: string) => void
  item: Item
}) => {
  const windowSize = useWindowSize()
  const isMobile = windowSize.width < 712
  const item_options = item.options
  let item_collections = collections.filter((c) => item_options.includes(c.id))

  if (item_collections.length > 6) {
    let random_collections = collections.filter(
      (c) => !item_options.includes(c.id)
    )
    item_collections = [
      ...item_collections,
      // ...random_collections.slice(0, 6 - item_collections.length),
    ].slice(0, 6)
  }
  const used_collections = useMemo(() => {
    return randomizeArray(item_collections)
  }, [item])
  
  return (
    <CollectionButtonsRoot isMobile={isMobile}>
      {used_collections.map((collection: any) => {
        return (
          <CollectionButton
            id={collection.id}
            onClick={handleAnswer}
            label={collection.name_de}
            icon={collection.icon}
          />
        )
      })}
    </CollectionButtonsRoot>
  )
}
function randomizeArray<T>(array: T[]): T[] {
  return array.sort(() => Math.random() - 0.5)
}

const CollectionButtonsRoot = styled.div<{ isMobile: boolean }>`
  margin-bottom: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 5px;
  /* filter: drop-shadow(0px 3px 6px rgba(0, 0, 0, 0.1)); */
  * {
    width: ${(props) =>
      props.isMobile ? 'calc(50% - 2.5px)' : 'calc(33% - 2.5px)'};
  }
`
